export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数字"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["姓名"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["节省"])}
}